"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddRightsholderCard = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const ButtonRegistrationRightsHolder_1 = require("@Components/Buttons/ButtonRegistrationRightsHolder");
const AddRightsholderCard = () => (react_1.default.createElement("section", { className: "add-rightsholder-card" },
    react_1.default.createElement("div", { className: 'info' },
        react_1.default.createElement("h1", null, "Add a Member account"),
        react_1.default.createElement("p", null, "A Member is a person or entity that administers musical works and receives the digital audio mechanical royalties from their use."),
        react_1.default.createElement(ButtonRegistrationRightsHolder_1.ButtonRegistrationRightsHolder, { mainColor: false })),
    react_1.default.createElement("img", { src: common_1.ILLUSTRATIONS.illustration4, alt: "img" })));
exports.AddRightsholderCard = AddRightsholderCard;
